// Onboarding Step 2 of 3 — sizing preferences.
// Per docs/design-spec.md §4.3.
//
// Stores tops / bottoms / dresses sizes locally in the user record. Skippable.
// (Backend doesn't have a sizing model yet; we persist to localStorage for v1
// and migrate to the user profile when the API gains size fields.)

import { useState } from 'react';
import Header from './components/Header';

const SIZES = ['XS', 'S', 'M', 'L', 'XL'];
const ROWS = [
  { key: 'tops',     label: 'Tops' },
  { key: 'bottoms',  label: 'Bottoms' },
  { key: 'dresses',  label: 'Dresses' },
];

const STORAGE_KEY = 'trimie_sizing';

function loadInitial() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
  } catch {
    return {};
  }
}

export default function OnboardingSizingPage({ onDone, onSkip }) {
  const [picks, setPicks] = useState(loadInitial);

  const choose = (rowKey, size) => {
    setPicks((prev) => ({ ...prev, [rowKey]: size }));
  };

  const save = () => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(picks));
    } catch { /* quota — fine, user can re-pick */ }
    onDone();
  };

  return (
    <div className="auth-shell">
      <Header
        onBack={null}
        action={{ icon: <span>Skip</span>, onClick: onSkip, ariaLabel: 'Skip' }}
      />

      <div className="onb-body">
        <span className="mono-eyebrow">Step 2 of 3</span>
        <h1>Your usual sizes.</h1>
        <p className="lead">We'll surface items in your size first.</p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
          {ROWS.map(({ key, label }) => (
            <div className="onb-size-group" key={key}>
              <div className="onb-size-group-label">{label}</div>
              <div className="onb-size-row">
                {SIZES.map((s) => (
                  <button
                    key={s}
                    type="button"
                    className={`onb-size-cell${picks[key] === s ? ' active' : ''}`}
                    onClick={() => choose(key, s)}
                    aria-pressed={picks[key] === s}
                  >
                    {s}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div style={{ flex: 1 }} />

        <button className="btn-purple btn-lg" onClick={save}>
          Continue
        </button>
      </div>
    </div>
  );
}
